import axios from 'axios';
import {
  SHOW_SHARE_OUTCOMES_REQUEST,
} from '../constants';

export const showShareOutcomesRequest = (params) => axios.post(SHOW_SHARE_OUTCOMES_REQUEST, params);
